import { useState } from 'react';
import styles from './Tabs.module.scss';

export default function TabsComponent({ tabs }) {
    const [active, setActive] = useState(tabs[0]?.id);

    const handleClick = (event) => {
        setActive(event.target.id);
    };

    return (
        <div className={styles.redlTabs}>
            <nav className={styles.redlTabsNav}>
                <ul className={styles.redlTabsList}>
                    {tabs.map(t => (
                        <li className={styles.redlTabsItem} key={t.id}>
                            <button
                                className={`${styles.redlTabsButton} ${active === t.id ? styles.redlTabsButtonActive : ''}`}
                                id={t.id}
                                onClick={handleClick}
                            >
                                <span data-text={t.text}>{t.text}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>
            <div className={styles.redlTabsContent}>
                {tabs.map(t => (
                    <div key={t.id}
                         className={`${styles.redlTabsPage} ${active === t.id ? styles.redlTabsPageActive : ''}`}>
                        {t.children}
                    </div>
                ))}
            </div>
        </div>
    );
}